import { render, staticRenderFns } from "./addStarterPack.vue?vue&type=template&id=b722f12a&"
import script from "./addStarterPack.vue?vue&type=script&lang=js&"
export * from "./addStarterPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports